import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AngularFirestore} from "@angular/fire/firestore";
import {Observable, combineLatest, of} from "rxjs";
import {map, switchMap} from "rxjs/operators";
// import { uniq, flatten } from 'lodash'

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  noAuthHeader = {
    headers: new HttpHeaders({"Content-Type": "application/json"}),
  };

  constructor(private http: HttpClient, private firestore: AngularFirestore) {
    this.firestore.firestore.settings({experimentalForceLongPolling: true});
  }

  //HttpMethods
  joined$: Observable<any>;

  //add project

  createProject(data) {
    return this.http.post("create_project", data, this.noAuthHeader);
  }

  // Create Project RS2 Import
  importRs2Project(data) {
    // return this.http.post("create_project_rs2_import", data, this.noAuthHeader);
    return this.http.post("import_rs2_project", data, this.noAuthHeader);
    // return this.http.post("import_rs2_files", data, this.noAuthHeader);
  }

  // Count total project records...
  projectCount(listType, uid) {
    if (listType === "filtered") {
      return this.firestore
        .collection("projects", (ref) => ref.where("author_user_id", "==", uid))
        .snapshotChanges();
    } else {
      return this.firestore.collection("projects").snapshotChanges();
    }
    // let query = this.firestore.collection("projects").ref.orderBy('date_created','desc');
    // return this.firestore.collection("projects", ref => query).snapshotChanges();
  }

  // Get project list

  getProjectList(
    limit,
    filterData,
    uid,
    listType,
    prevStartAt = null,
    firstInResponse = null,
    lastInResponse = null
  ) {
    //    console.log(limit,"limit",filterData,"filterData",uid,"uid",listType,"listType",prevStartAt,"prevStartAt",firstInResponse,"firstInResponse",lastInResponse,"lastInResponse");
    // const query = this.firestore.collection("projects"); // , ref => ref.where("accouting_ref","!=","")
    // const snapshot = await query.get();
    // const count = snapshot.l;
    if (listType === "filtered") {
      let query;
      if (prevStartAt && firstInResponse) {
        query = this.firestore
          .collection("projects")
          .ref.where("author_user_id", "==", uid)
          .startAt(prevStartAt)
          .endBefore(firstInResponse)
          .limit(limit); // orderBy('date_created','desc')
      } else if (lastInResponse) {
        query = this.firestore
          .collection("projects")
          .ref.where("author_user_id", "==", uid)
          .orderBy("date_created", "desc")
          .limit(limit)
          .startAfter(lastInResponse); // orderBy('date_created','desc')
      } else {
        query = this.firestore
          .collection("projects")
          .ref.where("author_user_id", "==", uid)
          .orderBy("date_created", "desc")
          .limit(limit);
        // .limit(limit).orderBy("date_created", "desc")
      }
      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      // if(filterData && filterData.contact_source_id){
      //   query = query.where('contact_source_id', '==', filterData.contact_source_id);
      // }
      if (filterData.start_date) {
        query = query.where(
          "date_created",
          ">=",
          new Date(filterData.start_date).getTime()
        );
      }
      if (filterData.end_date) {
        query = query.where(
          "date_created",
          "<=",
          new Date(filterData.end_date).getTime()
        );
      }
      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom_id", "==", showroomArr[0]);
      }
      return this.firestore
        .collection("projects", (ref) => query)
        .snapshotChanges();
    } else {
      let query;
      if (prevStartAt && firstInResponse) {
        query = this.firestore
          .collection("projects")
          .ref.orderBy("date_created", "desc")
          .startAt(prevStartAt)
          .endBefore(firstInResponse)
          .limit(limit);
      } else if (lastInResponse) {
        query = this.firestore
          .collection("projects")
          .ref.orderBy("date_created", "desc")
          .limit(limit)
          .startAfter(lastInResponse);
      } else {
        query = this.firestore
          .collection("projects")
          .ref.orderBy("date_created", "desc")
          .limit(limit);
      }
      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      // if(filterData && filterData.contact_source_id){
      //   query = query.where('contact_source_id', '==', filterData.contact_source_id);
      // }
      if (filterData.start_date) {
        query = query.where(
          "date_created",
          ">=",
          new Date(filterData.start_date).getTime()
        );
      }
      if (filterData.end_date) {
        query = query.where(
          "date_created",
          "<=",
          new Date(filterData.end_date).getTime()
        );
      }
      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom_id", "==", showroomArr[0]);
      }
      return this.firestore
        .collection("projects", (ref) => query)
        .snapshotChanges();
    }
  }

  // Get Project data by project id
  getProjectDataById(projectId) {
    return this.firestore
      .collection("projects")
      .doc(projectId)
      .snapshotChanges();
  }

  // Project list export...
  async exportProjectList(filterData, uid, listType) {
    if (listType === "filtered") {
      let query;
      query = this.firestore
        .collection("projects")
        .ref.where("author_user_id", "==", uid)
        .orderBy("date_created", "desc");
      if (
        filterData &&
        filterData.owner_contact_id &&
        filterData.owner_contact_id != ""
      ) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      if (
        filterData &&
        filterData.contact_source_id &&
        filterData.contact_source_id != ""
      ) {
        query = query.where(
          "contact_source_id",
          "==",
          filterData.contact_source_id
        );
      }
      // return this.firestore.collection("projects", ref => query ).snapshotChanges();
      const snapshot = await this.firestore
        .collection("projects", (ref) => query)
        .get();
      return snapshot;
    } else {
      /* return this.firestore.collection("projects", ref => ref.where('accounting_ref','!=',"")).snapshotChanges()
      .pipe(
        switchMap(projects=>{
          console.log(projects.length, "project.length!");
          return combineLatest(
            of(projects),
            combineLatest(
              projects.map(project =>
                this.firestore.collection('contacts', ref => ref.where('id', '==', project.payload.doc.data()['contact_id'])).snapshotChanges().pipe(
                  map(fields => fields)
                )
              )
            )
          )
        })
      ) */

      /* let query = this.firestore.collection("projects").ref.where('accounting_ref','!=',"");
        const snapshot = await this.firestore.collection('projects', ref => query).get();
        return snapshot;
      */

      let query;
      query = this.firestore
        .collection("projects")
        .ref.orderBy("date_created", "desc");
      if (
        filterData &&
        filterData.owner_contact_id &&
        filterData.owner_contact_id != ""
      ) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      if (
        filterData &&
        filterData.contact_source_id &&
        filterData.contact_source_id != ""
      ) {
        query = query.where(
          "contact_source_id",
          "==",
          filterData.contact_source_id
        );
      }
      //  return this.firestore.collection("projects", ref => query).snapshotChanges();
      const snapshot = await this.firestore
        .collection("projects", (ref) => query)
        .get();
      return snapshot;
    }
  }

  /*getProjectList(limit, uid,listType, prevStartAt=null, firstInResponse=null,lastInResponse=null) {
    if(listType==="filtered"){
      let query;
      if(prevStartAt && firstInResponse){
        query = this.firestore.collection("projects").ref.where('author_user_id','==',uid).startAt(prevStartAt)
        .endBefore(firstInResponse).limit(limit); // orderBy('date_created','desc')
      }
      else if(lastInResponse){
        query = this.firestore.collection("projects").ref.where('author_user_id','==',uid).orderBy("date_created", "desc").limit(limit).startAfter(lastInResponse); // orderBy('date_created','desc')
      }
      else {
        query = this.firestore.collection("projects").ref.where('author_user_id','==',uid).orderBy("date_created", "desc").limit(limit);
        // .limit(limit).orderBy("date_created", "desc")
      } 
      
      return this.firestore.collection("projects", ref => query ).snapshotChanges()
      .pipe(
        switchMap(steps=>{
          // return data from project map node;
          const projectIds = steps.map(item => item.payload.doc.id);
          
          return combineLatest(
            of(steps),
            combineLatest(
              projectIds.map(projectId =>
                this.firestore.collection('project_map_nodes', ref => ref.where('project_id', '==', projectId)).snapshotChanges().pipe(
                  map(fields => fields)
                )
              )
            )
          )
        })
      )
    }
    else { 
      let query;
      if(prevStartAt && firstInResponse){
        query = this.firestore.collection("projects").ref.orderBy("date_created", "desc").startAt(prevStartAt)
        .endBefore(firstInResponse).limit(limit);
      }
      else if(lastInResponse){
        query = this.firestore.collection("projects").ref.limit(limit).orderBy("date_created", "desc").startAfter(lastInResponse)
      }
      else {
        query = this.firestore.collection("projects").ref.limit(limit).orderBy("date_created", "desc");
      }
      return this.firestore.collection("projects", ref => query).snapshotChanges()
      .pipe(
        switchMap(steps=>{
          // return data from project map node;
          const projectIds = steps.map(item => item.payload.doc.id);
          return combineLatest(
            of(steps),
            combineLatest(
              projectIds.map(projectId =>
                this.firestore.collection('project_map_nodes', ref => ref.where('project_id', '==', projectId)).snapshotChanges().pipe(
                  map(fields => fields)
                )
              )
            )
          )
        })
      )
     }
  } */

  // get project list
  getDesignerProjectList(uid) {
    // return this.firestore.collection("projects", ref => ref.orderBy("date_created", "desc") ).snapshotChanges();
    return this.firestore
      .collection("projects", (ref) => ref.orderBy("date_created", "desc"))
      .snapshotChanges()
      .pipe(
        switchMap((steps) => {
          // return data from project map node;
          const projectIds = steps.map((item) => item.payload.doc.id);
          // const contactIds = steps.map((item:any) => item.payload.doc.data().contact_id);
          return combineLatest(
            of(steps),
            combineLatest(
              projectIds.map((projectId) =>
                this.firestore
                  .collection("project_map_nodes", (ref) =>
                    ref.where("project_id", "==", projectId)
                  )
                  .snapshotChanges()
                  .pipe(map((fields) => fields))
              )
            )
          );
        })
      );
  }

  // get project detail by id
  getProjectById(params) {
    return this.firestore
      .collection("projects")
      .doc(params.projectId)
      .snapshotChanges()
      .pipe(
        switchMap((steps) => {
          // return data from project map node;
          const projectIds = [steps.payload.id]; //steps.payload.doc.id;
          return combineLatest(
            of(steps),
            combineLatest(
              projectIds.map((projectId) =>
                this.firestore
                  .collection("project_map_nodes", (ref) =>
                    ref
                      .where("project_id", "==", projectId)
                      .orderBy("date_created", "desc")
                  )
                  .snapshotChanges()
                  .pipe(map((fields) => fields))
              )
            )
          );
        })
      );
  }

  // get client list
  getClientList() {
    //, ref => ref.where('record_type', '==', 'lead')
    return this.firestore.collection("contacts").snapshotChanges();
  }

  // get project list...
  getProjectList2() {
    //, ref => ref.where('record_type', '==', 'lead')
    return this.firestore
      .collection("projects", (ref) => ref.orderBy("date_created", "desc"))
      .snapshotChanges();
  }

  // get project status list
  getProjectStatusList() {
    return this.firestore
      .collection("project_status", (ref) => ref.orderBy("date_created", "asc"))
      .snapshotChanges();
  }

  // Get contact list
  getContactProjectList(contact_id) {
    return this.firestore
      .collection("projects", (ref) =>
        ref
          .where("contact_id", "==", contact_id)
          .orderBy("date_created", "desc")
      )
      .snapshotChanges();
  }

  //  get project map field
  getProjectMapStep() {
    // return this.firestore.collection('project_map_step').snapshotChanges();
    return this.firestore
      .collection("project_map_steps", (ref) => ref.orderBy("number"))
      .snapshotChanges()
      .pipe(
        switchMap((steps) => {
          // return steps;
          const stepIds = steps.map((item) => item.payload.doc.id);

          return combineLatest(
            of(steps),
            combineLatest(
              stepIds.map((stepId) => {
                let arr = [];
                arr.push(stepId);
                if (
                  stepId === "axHCZ2T6Gdkp1H6XjPRh" ||
                  stepId === "evwdciVNp0SQ6Qwxd7xy"
                ) {
                  arr.push("evwdciVNp0SQ6Qwxd790");
                }
                return this.firestore
                  .collection("project_map_fields", (ref) =>
                    ref
                      .where("project_map_step_id", "in", arr)
                      .orderBy("date_created", "asc")
                  )
                  .snapshotChanges()
                  .pipe(map((fields) => fields));
              })
            )
          );
        })
        // map(([steps, fields]) => {

        //   return steps.map(step => {
        //     return {
        //       ...step,
        //       field: fields
        //     }
        //   })
        // })
      );
  }

  // add project map node...
  // addProjectMapStepNode(data): Observable<any> {
  //   return this.http.post("add_project_map_node", data, this.noAuthHeader);
  // }

  // create project map step node...
  addProjectMapStepFile(data): Observable<any> {
    return this.http.post("create_file", data, this.noAuthHeader);
  }

  uploadFileToDrive(data): Observable<any> {
    return this.http.post("drive_file_upload", data, this.noAuthHeader);
  }
  // Code to get the list of ids
  getIdsForStep2Precondition() {
    return this.firestore
      .collection("project_map_fields", (ref) =>
        ref.where("name", "in", [
          "Retainer Agreement",
          "Purchase Agreement (Cabinetry)",
        ])
      )
      .snapshotChanges();
  }
  getStep2FieldIds() {
    return this.firestore
      .collection("project_map_fields", (ref) =>
        ref.where("name", "in", [
          "Floor Plan",
          "Design",
          "Desired Production Week",
        ])
      )
      .snapshotChanges();
  }

  checkStep2Precondition(ids) {
    return this.firestore
      .collection("files", (ref) =>
        ref.where("project_map_field_id", "in", ids)
      )
      .snapshotChanges();
  }

  // Send email
  initEmail(data): Observable<any> {
    return this.http.post("init_email", data, this.noAuthHeader);
  }

  getAllFileList(projectId = null) {
    if (projectId !== null) {
      return this.firestore
        .collection("files", (ref) =>
          ref
            .where("project_id", "==", projectId)
            .orderBy("date_created", "desc")
        )
        .snapshotChanges(); //
    } else {
      return this.firestore
        .collection("files", (ref) => ref.orderBy("date_created", "desc"))
        .snapshotChanges();
    }
  }

  // Get project files...
  getProjectFiles(projectId) {
    return this.firestore
      .collection("files", (ref) => ref.where("project_id", "==", projectId))
      .snapshotChanges();
  }

  updateNode(id, data) {
    return this.firestore.collection("project_map_nodes").doc(id).update(data);
  }

  getTechnicalDesigner() {
    return this.firestore
      .collection("contacts", (ref) =>
        ref
          .where("is_technical_designer", "==", true)
          .where("is_technical_designer_active", "==", true)
      )
      .snapshotChanges();
  }

  async getProjectMapDriveLink(project_id) {
    // return this.firestore.collection('files', ref => ref.where('project_id', '==', project_id)).snapshotChanges();
    return await new Promise((resolve) => {
      this.firestore
        .collection("files", (ref) =>
          ref
            .where("project_id", "==", project_id)
            .orderBy("date_created", "desc")
        )
        .snapshotChanges()
        .subscribe((list) => {
          resolve(list);
        });
    });
  }

  getProjectMapNode(project_id) {
    return this.firestore
      .collection("project_map_nodes", (ref) =>
        ref
          .where("project_id", "==", project_id)
          .orderBy("date_created", "desc")
      )
      .snapshotChanges();
  }

  async getProjectMapNodePromise(project_id) {
    // return this.firestore.collection('project_map_nodes', ref => ref.where('project_id', '==', project_id)).snapshotChanges();
    return await new Promise((resolve) => {
      // .orderBy('date_created', 'desc')
      this.firestore
        .collection("project_map_nodes", (ref) =>
          ref
            .where("project_id", "==", project_id)
            .orderBy("date_created", "desc")
        )
        .snapshotChanges()
        .subscribe((list) => {
          resolve(list);
        });
    });
  }

  // get Project Contact Details for Project Overview section
  getProjectContactDetail(id) {
    return this.firestore
      .collection("contacts", (ref) => ref.where("id", "==", id))
      .snapshotChanges();
  }

  // Get Project detail by user_id
  getContactByUserId(user_id) {
    return this.firestore
      .collection("contacts", (ref) => ref.where("user_id", "==", user_id))
      .snapshotChanges();
  }

  // Fetch Other Projects...
  getOtherProjects(contact_id) {
    return this.firestore
      .collection("projects", (ref) =>
        ref.where("contact_id", "==", contact_id)
      )
      .snapshotChanges();
  }

  // Get project map file fields
  getFileFields(field_id, project_id) {
    return this.firestore
      .collection("files", (ref) =>
        ref
          .where("project_map_field_id", "==", field_id)
          .where("project_id", "==", project_id)
          .orderBy("date_created", "desc")
      )
      .snapshotChanges();
  }

  getFileFieldName(field_id) {
    return this.firestore
      .collection("project_map_fields", (ref) =>
        ref.where("id", "==", field_id)
      )
      .snapshotChanges();
  }

  // Code to get the projet appointments.
  getProjectAppointmentList(projectId) {
    if (projectId) {
      return this.firestore
        .collection("calendar_events", (ref) =>
          ref.where("project_id", "==", projectId)
        )
        .snapshotChanges();
    } else {
      return of([]);
    }
  }

  // code to get project reminders list...
  getProjectReminderList(projectId) {
    if (projectId) {
      return this.firestore
        .collection("comments", (ref) =>
          ref.where("project_id", "==", projectId)
        )
        .snapshotChanges();
    } else {
      return of([]);
    }
  }

  // code to get notes list
  getProjectNotesList(projectId) {
    if (projectId) {
      return this.firestore
        .collection("comments", (ref) =>
          ref.where("project_id", "==", projectId)
        )
        .snapshotChanges();
    } else {
      return of([]);
    }
  }

  // Create File...
  createFile(form) {
    const id = this.firestore.createId();
    form.id = id;
    return this.firestore.collection("files").doc(id).set(form);
  }

  // Get email recipients
  getEmailRecipient(id) {
    return this.firestore
      .collection("email_recipients", (ref) => ref.where("id", "==", id))
      .get();
  }

  // Get System mode..
  getSystemMode() {
    return this.firestore.collection("system").snapshotChanges();
  }

  getDesignerProjects(designer_id) {
    return this.firestore
      .collection("projects", (ref) =>
        ref.where("owner_contact_id", "==", designer_id)
      )
      .snapshotChanges(); //.orderBy('date_created','desc')
  }

  // Get All Projects
  getAllProjects() {
    return this.firestore.collection("projects").snapshotChanges(); //.orderBy('date_created','desc')
  }

  // Add technical Designer
  addTechnicalDesigner(form) {
    const TDId = this.firestore.createId();
    form.id = TDId;
    return this.firestore.collection("project_map_nodes").doc(TDId).set(form);
  }
  // Check technical designer value...
  getProjectTechincalDesigner(project_id, field_id) {
    return this.firestore
      .collection("project_map_nodes", (ref) =>
        ref
          .where("project_id", "==", project_id)
          .where("field_id", "==", field_id)
      )
      .snapshotChanges();
  }

  // Fetch all child projects...
  async getChildProjects(project_id) {
    // return this.firestore.collection('projects', ref => ref.where('created_from_project_id', '==', project_id)).snapshotChanges();
    return await new Promise((resolve) => {
      this.firestore
        .collection("projects", (ref) =>
          ref.where("created_from_project_id", "==", project_id)
        )
        .snapshotChanges()
        .subscribe((list) => {
          resolve(list);
        });
    });
  }

  // get project map step nodes
  getProjectMapFilesByStep(project_id, project_map_step_id) {
    return this.firestore
      .collection("files", (ref) =>
        ref
          .where("project_id", "==", project_id)
          .where("project_map_step_id", "==", project_map_step_id)
          .orderBy("date_created", "desc")
      )
      .get();
  }
}
